import { RemoteService } from '../../http/RemoteService.js';

export class HttpService {
    constructor(options = {}) {
        const {
            remoteService = null,
            ...remoteOptions
        } = options;

        this.remote = remoteService || new RemoteService(remoteOptions);
    }

    async request(method, path, data = null, options = {}) {
        try {
            return await this.remote.call(method, path, data, options);
        } catch (response) {
            throw this._toClientError(response);
        }
    }

    async get(path, query = null, options = {}) {
        return this.request('GET', path, query, options);
    }

    async post(path, body = null, options = {}) {
        return this.request('POST', path, body, options);
    }

    async put(path, body = null, options = {}) {
        return this.request('PUT', path, body, options);
    }

    async delete(path, query = null, options = {}) {
        return this.request('DELETE', path, query, options);
    }

    _toClientError(response) {
        const payload = response?.type === 'error'
            ? response.payload
            : response?.contractError ?? null;
        const error = new Error(payload?.message || response?.statusText || 'HTTP request failed.');
        error.name = 'HttpServiceError';
        error.status = response?.status || 500;
        error.code = payload?.code ?? null;
        error.details = payload?.details ?? null;
        error.description = payload?.description ?? null;
        error.correlationId = payload?.correlationId ?? null;
        error.payload = payload;
        error.response = response;
        return error;
    }
}
